import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { bootstrap } from "@/app/bootstrap";
import { App } from "@/app/App";
import "./index.css";
import "material-symbols/outlined.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found. Check your index.html.");
}

bootstrap()
  .then(() => {
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    // Log critical error to user
    console.error("Bootstrap failed:", error);
  });
